(() => {
  if (window.bigitiHalloweenMotion) return;
  const body = document.body;
  if (!body?.classList.contains('bigiti-halloween-theme')) return;

  const namespace = 'http://www.w3.org/2000/svg';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const controlSelector = 'button, [role="button"], input[type="submit"]';
  const hostSelector = '.bigiti-collection-explorer, .bigiti-faq, .bigiti-newsletter, .shopify-section-group-footer-group';
  const timers = new Set();
  const recentControls = new WeakMap();
  const activeControls = new Map();
  let hosts = [];
  let layer;
  let observer;
  let running = false;
  let frame = 0;
  let flightPlayed = false;

  const later = (callback, delay) => {
    const timer = window.setTimeout(() => {
      timers.delete(timer);
      callback();
    }, delay);
    timers.add(timer);
    return timer;
  };

  const svg = (kind) => {
    const element = document.createElementNS(namespace, 'svg');
    element.setAttribute('viewBox', kind === 'web' ? '0 0 160 160' : '0 0 80 48');
    element.setAttribute('aria-hidden', 'true');
    element.setAttribute('focusable', 'false');
    element.dataset.bhArt = kind;
    const path = document.createElementNS(namespace, 'path');
    path.setAttribute('d', kind === 'web'
      ? 'M0 0H157M0 0L145 60M0 0L111 111M0 0L60 145M0 0V157M31 0Q25 8 28 12Q22 17 22 22Q15 22 12 28Q5 26 0 31M63 0Q52 16 57 24Q44 35 45 45Q31 47 24 57Q11 52 0 63M100 0Q84 25 91 38Q70 53 71 71Q50 73 38 91Q18 85 0 100M139 0Q119 34 128 53Q99 73 99 99Q69 103 53 128Q26 119 0 139'
      : 'M40 20 33 11 32 22C22 10 13 6 2 4 8 14 9 23 5 31 15 25 22 26 27 34 31 30 35 33 40 44 45 33 49 30 53 34 58 26 65 25 75 31 71 23 72 14 78 4 67 6 58 10 48 22L47 11Z');
    element.append(path);
    return element;
  };

  const decorate = () => {
    hosts = hosts.filter((host) => host.isConnected);
    document.querySelectorAll(hostSelector).forEach((host) => {
      if (hosts.length >= 5 || host.hasAttribute('data-bh-web-host')) return;
      host.dataset.bhWebHost = hosts.length % 2 ? 'right' : 'left';
      if (getComputedStyle(host).position === 'static') host.dataset.bhPositioned = '';
      const web = svg('web');
      if (hosts.length === 0) {
        const spider = document.createElementNS(namespace, 'g');
        spider.dataset.bhSpider = '';
        const silk = document.createElementNS(namespace, 'path');
        silk.setAttribute('d', 'M63 53V113');
        const legs = document.createElementNS(namespace, 'path');
        legs.setAttribute('d', 'M59 116 51 110 47 114M59 120 49 118 45 123M59 123 51 128 50 134M67 116 75 110 79 114M67 120 77 118 81 123M67 123 75 128 76 134');
        const abdomen = document.createElementNS(namespace, 'ellipse');
        abdomen.setAttribute('cx', '63');
        abdomen.setAttribute('cy', '120');
        abdomen.setAttribute('rx', '5');
        abdomen.setAttribute('ry', '8');
        abdomen.setAttribute('fill', 'currentColor');
        spider.append(silk, legs, abdomen);
        web.append(spider);
      }
      host.append(web);
      hosts.push(host);
    });
  };

  const removeBusy = (control) => {
    const state = activeControls.get(control);
    if (!state) return;
    state.art.remove();
    window.clearTimeout(state.timeout);
    timers.delete(state.timeout);
    activeControls.delete(control);
  };

  const isBusy = (control) => {
    if (control.getAttribute('aria-busy') === 'true') return true;
    const loading = control.getAttribute('data-loading');
    if (loading !== null && loading !== 'false') return true;
    if (control.matches('.loading, .is-loading')) return true;
    const clicked = recentControls.get(control);
    return Boolean(control.disabled && clicked && Date.now() - clicked < 30000 && !control.matches('.is-added'));
  };

  const placeBusy = (control, art) => {
    const rect = control.getBoundingClientRect();
    art.hidden = rect.bottom <= 0 || rect.top >= window.innerHeight || rect.width === 0;
    art.style.left = `${Math.max(24, Math.min(window.innerWidth - 24, rect.right - 18))}px`;
    art.style.top = `${Math.max(18, Math.min(window.innerHeight - 20, rect.top - 8))}px`;
  };

  const refreshBusy = (control) => {
    if (!(control instanceof Element) || !control.matches(controlSelector)) return;
    if (!control.isConnected || !isBusy(control)) {
      removeBusy(control);
      return;
    }
    if (activeControls.has(control) || activeControls.size >= 3) return;
    const art = svg('bat');
    art.dataset.bhBusyBat = '';
    layer.append(art);
    placeBusy(control, art);
    const timeout = later(() => removeBusy(control), 30000);
    activeControls.set(control, { art, timeout });
  };

  const reposition = () => {
    if (frame || !activeControls.size) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      activeControls.forEach(({ art }, control) => {
        if (!control.isConnected) removeBusy(control);
        else placeBusy(control, art);
      });
    });
  };

  const playFlight = () => {
    if (flightPlayed || reduceMotion.matches || document.hidden) return;
    flightPlayed = true;
    for (let index = 0; index < 2; index += 1) {
      const art = svg('bat');
      art.dataset.bhFlight = String(index);
      layer.append(art);
      later(() => art.remove(), 4300);
    }
  };

  const onInteraction = (event) => {
    if (!(event.target instanceof Element)) return;
    const control = event.target.closest(controlSelector);
    if (!control || control.disabled || control.getAttribute('aria-disabled') === 'true') return;
    recentControls.set(control, Date.now());
    queueMicrotask(() => {
      if (running) refreshBusy(control);
    });
  };

  const onMutations = (records) => {
    const changed = new Set();
    records.forEach((record) => {
      if (record.type === 'attributes') {
        const control = record.target.closest(controlSelector);
        if (control) changed.add(control);
      }
    });
    changed.forEach(refreshBusy);
    activeControls.forEach((state, control) => {
      if (!control.isConnected) removeBusy(control);
    });
  };

  const onPreferenceChange = () => {
    if (reduceMotion.matches) layer.querySelectorAll('[data-bh-flight]').forEach((art) => art.remove());
  };

  const onVisibility = () => {
    if (document.hidden) layer.querySelectorAll('[data-bh-flight]').forEach((art) => art.remove());
  };

  const start = () => {
    if (running) return;
    running = true;
    layer = document.createElement('div');
    layer.dataset.bhMotionLayer = '';
    layer.setAttribute('aria-hidden', 'true');
    body.append(layer);
    decorate();
    observer = new MutationObserver(onMutations);
    observer.observe(body, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-busy', 'data-loading', 'class', 'disabled'] });
    document.addEventListener('click', onInteraction, true);
    document.addEventListener('shopify:section:load', decorate);
    document.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('scroll', reposition, { passive: true });
    window.addEventListener('resize', reposition, { passive: true });
    reduceMotion.addEventListener('change', onPreferenceChange);
    playFlight();
  };

  const stop = () => {
    running = false;
    observer?.disconnect();
    timers.forEach((timer) => window.clearTimeout(timer));
    timers.clear();
    activeControls.clear();
    cancelAnimationFrame(frame);
    frame = 0;
    layer?.remove();
    hosts.forEach((host) => {
      host.querySelector(':scope > [data-bh-art="web"]')?.remove();
      host.removeAttribute('data-bh-web-host');
      host.removeAttribute('data-bh-positioned');
    });
    hosts = [];
    document.removeEventListener('click', onInteraction, true);
    document.removeEventListener('shopify:section:load', decorate);
    document.removeEventListener('visibilitychange', onVisibility);
    window.removeEventListener('scroll', reposition);
    window.removeEventListener('resize', reposition);
    reduceMotion.removeEventListener('change', onPreferenceChange);
  };

  window.bigitiHalloweenMotion = { start, stop };
  window.addEventListener('pagehide', stop);
  window.addEventListener('pageshow', start);
  start();
})();
